"use client";

import React from "react";
import type { AgentThinkingTraceStep } from "@/types/createAgent";
import "./agent-activity.css";

interface AgentTypingDotsProps {
  status?: string | null;
  steps?: AgentThinkingTraceStep[];
  isFinalizing?: boolean;
}

/**
 * Show the current status until the first activity step arrives.
 * ThinkingTrace uses the same text treatment once details are available.
 */
export default function AgentTypingDots({
  status,
  steps = [],
  isFinalizing = false,
}: AgentTypingDotsProps) {
  const latestStep = steps[steps.length - 1];
  const label =
    status?.trim() ||
    latestStep?.summary.trim() ||
    latestStep?.title ||
    (isFinalizing ? "Preparing options" : "Your designer is thinking");

  return (
    <div
      data-agent-thinking-trace="pending"
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="agent-activity agent-activity-pending"
    >
      <span className="agent-activity-status">{label}</span>
    </div>
  );
}
